import { call, put, select } from 'redux-saga/effects';
import { setDefaultMicrophone, setDefaultSpeaker } from '../../../state/audioDevice/audioDeviceSlice';
import { selectCallSessions } from '../../../state/callSessions/callSessionsSlice';
import { setAudioOutputDevice } from '../../../utils/audioUtils';
import { saveDefaultMicrophone, saveDefaultSpeaker } from '../../../browser/storage';

export function* changeAudioDeviceSaga(action) {
  const { deviceType, deviceId } = action.payload;
  try {
    if (deviceType === 'microphone') {
      // Get active call sessions
      const callSessions = yield select(selectCallSessions)
      const activeCalls = callSessions.filter(session => session.status === 'accepted');
      // If there are active calls, update their microphone
      if (activeCalls.length > 0) {
        // Get new stream from desired microphone
        const stream = yield call([navigator.mediaDevices, 'getUserMedia'], {
          audio: {
            deviceId: { exact: deviceId }
          }
        });

        // Update each active call session
        for (const callSession of activeCalls) {
          if (callSession.session) {
            const peerConnection = callSession.session.sessionDescriptionHandler.peerConnection;
            const senders = peerConnection.getSenders();
            const audioSender = senders.find(sender => sender.track?.kind === 'audio');

            if (audioSender) {
              // Get the audio track from new stream
              const [audioTrack] = stream.getAudioTracks();
              if (audioTrack) {
                // Preserve mute state
                if (callSession.isMuted) {
                  audioTrack.enabled = false;
                }

                yield call([audioSender, 'replaceTrack'], audioTrack);
                console.log('Successfully replaced audio track for session:', callSession.id);
              }
            }
          }
        }
      }
      yield call(saveDefaultMicrophone, deviceId);
      yield put(setDefaultMicrophone({ microphone: deviceId }));
    } else {
      yield call(setAudioOutputDevice, deviceId);
      yield call(saveDefaultSpeaker, deviceId);
      yield put(setDefaultSpeaker({ speaker: deviceId }));
    }
  } catch (error) {
    console.error('Error changing device:', error);
  }

}